import { StyledSimpleImage } from './SimpleImage.styled';
import { useContext } from 'react';
import { GameAssetsContext } from '../../GameAssetsContext/GameAssetsContext';
import useTransform from './useTransfrom.hook';

export default function SimpleImage({
  transform,
  relativeTo,
  imageId,
  debug,
  pixelSize,
}) {
  const gameAssets = useContext(GameAssetsContext);
  const { responsiveTransform, originalSize } = useTransform({
    transform,
    relativeTo,
    originalSize,
    imageId,
    pixelSize,
  });

  return (
    <>
      {responsiveTransform && (
        <StyledSimpleImage
          responsiveTransform={responsiveTransform}
          originalSize={originalSize}
        >
          <div className="game-object-wrapper">
            <img
              className="game-object"
              src={gameAssets.state.images[imageId].src}
              alt="simple imgage game object"
            />
            {debug && (
              <div className="debug-grid">
                <div className="grid-box"></div>
                <div className="grid-box"></div>
                <div className="grid-box"></div>
                <div className="grid-box"></div>
              </div>
            )}
          </div>
        </StyledSimpleImage>
      )}
    </>
  );
}
